import { Vue } from 'vue-property-decorator';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';
import {
  FilterParams,
  IFilterState
} from '@/components/ui/filters/store/types';

/**
 * --------------------------------------------------
 *	Filter Getters
 * --------------------------------------------------
 **/
export const FilterGetters: IFilterGetters = {
  getFilterData: state => (
    params: Pick<FilterParams, 'name' | 'searchTerm'>
  ) => {
    return state[params.name]?.[params.searchTerm]?.data || [];
  },
  isFilterFetchingData: state => (
    params: Pick<FilterParams, 'name' | 'searchTerm'>
  ) => {
    return state[params.name]?.[params.searchTerm]?.isFetchingData ?? false;
  },
  canFilterFetchMoreData: state => (
    params: Pick<FilterParams, 'name' | 'searchTerm'>
  ) => {
    if (!state[params.name]?.[params.searchTerm]) {
      return true;
    }
    return (
      state[params.name][params.searchTerm].currentPage <
      state[params.name][params.searchTerm].totalPages
    );
  }
};

/**
 * --------------------------------------------------
 *	Filter Getters Type
 * --------------------------------------------------
 **/
export type IFilterGetters = GetterTree<IFilterState, IRootState>;
